/* Kanadeal — decoupe le titre HERO des pages categorie en mots
   (chaque mot = <span.kd-w><span.kd-wi>) pour le rendu deconstruit/kinetique
   defini dans kd-category-hero.css. Idempotent + retry pour hero GemPages. */
(function () {
  function split() {
    var main = document.querySelector('main[data-template="collection"]');
    if (!main) return false;
    var h1 = main.querySelector('.text-block h1');
    if (!h1) return false;
    if (h1.classList.contains('kd-hero-split')) return true;
    var text = (h1.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return false;
    var words = text.split(' ');
    h1.classList.add('kd-hero-split');
    h1.setAttribute('aria-label', text);
    h1.innerHTML = '';
    words.forEach(function (w, i) {
      var outer = document.createElement('span');
      outer.className = 'kd-w';
      outer.setAttribute('aria-hidden', 'true');
      outer.style.setProperty('--i', i);
      var inner = document.createElement('span');
      inner.className = 'kd-wi';
      inner.textContent = w;
      outer.appendChild(inner);
      h1.appendChild(outer);
    });
    h1.style.setProperty('--n', words.length);
    return true;
  }
  function init() {
    if (split()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (split() || tries > 24) clearInterval(iv);
    }, 150);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
